import request from "root/js/request";

export const getWarehousesSupplyDynamic = async ({
  cabinet_id,
  category_id__in,
  brand_id__in,
  subject_id__in,
  barcode__in,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/forecasting/warehouse_supply_dynamic/",
    method: "get",
    params: {
      cabinet_id,
      category_id__in,
      brand_id__in,
      subject_id__in,
      barcode__in,
      ...rest,
    },
  });
  return response.data;
};
